import React from "react";
import { TextField, Button, Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import { Formik } from "formik";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { actions } from "../CrudAndRedux/ProfileRedux";
import { useDispatch, useSelector } from "react-redux";
import jalaali from "jalaali-js";
import { getUserTransaction } from "../CrudAndRedux/ProfileCrud";
import convertPersianToEnglishNumber from "../../../utils/convert-persian-to-english-number";

const TransactionSearchCard = (props) => {
  const [selectedDay, setSelectedDay] = React.useState(null);
  const [desDay, setDesDay] = React.useState(null);

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  const renderSrcCustomInput = ({ ref }) => {
    return (
      <input
        readOnly
        placeholder="از تاریخ"
        value={
          selectedDay
            ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
            : ""
        }
        ref={ref}
        style={{
          textAlign: "right",
          padding: "1.9rem 1rem",
          fontSize: "1rem",
          border: "1px solid #b5b5c3",
          width: "100%",
          borderRadius: "12px",
          color: "currentColor",
          height: "48px",
          outline: "none",
          backgroundColor: "white",
        }}
        className="my-custom-input-class" // a styling class
      />
    );
  };

  const renderDesCustomInput = ({ ref }) => {
    return (
      <input
        readOnly
        placeholder="تا تاریخ"
        value={desDay ? `${desDay.year}/${desDay.month}/${desDay.day}` : ""}
        ref={ref}
        style={{
          textAlign: "right",
          padding: "1.9rem 1rem",
          fontSize: "1rem",
          border: "1px solid #b5b5c3",
          width: "100%",
          borderRadius: "12px",
          color: "currentColor",
          height: "48px",
          outline: "none",
          backgroundColor: "white",
        }}
        className="my-custom-input-class" // a styling class
      />
    );
  };

  return (
    <div
      style={{ border: "1px solid #d9d9d9", borderRadius: 13 }}
      className="row flex-column bg-white shadow-sm p-5 mx-auto mt-3 text-right container"
    >
      <h2 className="my-4">
        <b>جست و جوی تراکنش</b>
      </h2>

      <Formik
        enableReinitialize
        initialValues={{}}
        onSubmit={(values) => {

          const startDate = jalaali
            .jalaaliToDateObject(
              selectedDay?.year,
              selectedDay?.month,
              selectedDay?.day
            )
            .toLocaleDateString()
            .split("/");

          const endDate = jalaali
            .jalaaliToDateObject(desDay?.year, desDay?.month, desDay?.day)
            .toLocaleDateString()
            .split("/");

          values.startDate = `${+startDate[2]}-${+startDate[0]}-${+startDate[1]}`;
          values.endDate = `${+endDate[2]}-${+endDate[0]}-${+endDate[1]}`;

          getUserTransaction(authState.user.token, values).then((res) =>
            dispatch(actions.getAllTransactions(res.data.data))
          );
        }}
      >
        {({ handleSubmit, setFieldValue }) => {
          return (
            <div className="d-flex flex-wrap mt-5">
              <div className="col-12 col-md-3 my-1 p-0">
                <div className="p-4">

                  <FormControl variant="outlined" >
                    <InputLabel htmlFor="outlined-job-native-simple">نوع تراکنش</InputLabel>
                    <Select
                      style={{ borderRadius: "13px", cursor: 'pointer' }}
                      native
                      // value={state.job}
                      onChange={(e) =>
                        setFieldValue("transactionType", e.target.value)
                      }
                      label="نوع تراکنش"
                      inputProps={{
                        name: 'transactionType',
                        id: 'outlined-job-native-simple',
                      }}
                    >
                      <option value={1} style={{ cursor: 'pointer' }}>همه</option>
                      <option value={2} style={{ cursor: 'pointer' }}>برداشت</option>
                      <option value={3} style={{ cursor: 'pointer' }}>واریز</option>
                    </Select>
                  </FormControl>

                </div>
              </div>
              <div className="col-6 col-md-3 my-1 p-0">
                <div className="p-4">
                  <DatePicker
                    value={selectedDay}
                    onChange={setSelectedDay}
                    name="departureDate"
                    shouldHighlightWeekends
                    renderInput={renderSrcCustomInput}
                    style={{ height: "45px", width: "100%" }}
                    locale="fa"
                    calendarPopperPosition="bottom"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 my-1 p-0">
                <div className="p-4">
                  {" "}
                  <DatePicker
                    value={desDay}
                    onChange={setDesDay}
                    name="departureDate"
                    shouldHighlightWeekends
                    renderInput={renderDesCustomInput}
                    style={{ height: "45px", width: "100%" }}
                    locale="fa"
                    calendarPopperPosition="bottom"
                  />
                </div>
              </div>
              <div
                className="col-12 col-md-3 my-1 d-flex p-4 align-items-center"
                style={{ justifyContent: "flex-end" }}
              >
                <Button
                  className="ticket-search-btn  text-white "
                  style={{
                    backgroundColor: "#6dd06d ",
                    borderRadius: "13px",
                    height: "4rem",
                  }}
                  onClick={() => handleSubmit()}
                >
                  <h6 className="my-auto text-white">
                    <b>جستجو</b>
                  </h6>
                </Button>
              </div>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default TransactionSearchCard;
